<template>
  <form @submit.prevent="handleSubmit">
    <div class="mb-3">
      <label for="groupName" class="form-label">{{ t('groups.nameLabel') }}</label>
      <input
        type="text"
        class="form-control borderless-input"
        id="groupName"
        v-model="formData.name"
        required
        :placeholder="t('groups.namePlaceholder')"
        :class="{ 'is-invalid': errors.name }"
      />
      <div v-if="errors.name" class="invalid-feedback">
        {{ errors.name }}
      </div>
    </div>
  </form>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({
      name: ''
    })
  }
});

const emit = defineEmits(['submit', 'cancel', 'validation-error', 'update:form-data']);

const formData = ref({ ...props.initialData });
const errors = ref({});

watch(() => props.initialData, (newVal) => {
  formData.value = { ...newVal };
}, { deep: true });

watch(formData, (newVal) => {
  emit('update:form-data', newVal);
}, { deep: true });

const validate = () => {
  let isValid = true;
  errors.value = {};

  if (!formData.value.name?.trim()) {
    errors.value.name = t('groups.nameRequired');
    isValid = false;
    emit('validation-error');
  }

  return isValid;
};

const handleSubmit = () => {
  if (validate()) {
    emit('submit', formData.value);
  }
};

const setServerErrors = (serverErrors) => {
  errors.value = { ...serverErrors };
};

defineExpose({
  validateForm: validate,
  submit: handleSubmit,
  setServerErrors
});
</script>
